<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal :visible="showFinancialItemPremiumsModal" :data="model" :title="$t('Premiums')" size="lg"
                   @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :ok-title="$t('Submit')"
                   :is-loading="loading" scrollable modal-class="mobile-full-screen">
      <premium-tiers ref="premiumTiers" :model="model" show-minimum-premium-field/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import PremiumTiers from "../../../../../core/components/premium-tiers/PremiumTiers";
  import _ from 'lodash';
  import PremiumsFormData from "@/modules/sales/models/PremiumsFormData.model";
  import PercentageInputWidget from "@/core/widgets/PercentageInputWidget.vue";
  import CurrencyInputWidget from "@/core/widgets/CurrencyInputWidget.vue";
  import Premium from "@/core/components/premium-tiers/Premium.model";


  const {mapState, mapActions} = createNamespacedHelpers('reservations');

  export default {
    name: "FinancialItemPremiumsModal",
    components: {PremiumTiers, ArtisioModal, CurrencyInputWidget, PercentageInputWidget},
    data: () => {
      return {
        loading: false,
        model: new PremiumsFormData()
      }
    },
    computed: {
      ...mapState({
        reservation: state => state.view.termsData.financialItemPremiumsModal.reservation,
        editObject: state => state.view.termsData.financialItemPremiumsModal.object,
        showFinancialItemPremiumsModal: state => state.view.termsData.financialItemPremiumsModal.show,
      }),
    },
    methods: {
      ...mapActions(['hideFinancialItemPremiumsModal', 'updateLotTerms', 'getReservation']),
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t('Changing terms will trigger automatic recalculation of all associated invoices and settlements. Would you like to proceed?'));
        if (!success) {
          return
        }
        this.loading = true;
        let tmpData = this.model.toJSON(this.reservation.lot.financial_item);
        let response = await this.updateLotTerms({
          lotUuid: this.reservation.lot.uuid,
          data: {
            minimum_premium: tmpData.minimum_premium,
            premiums: tmpData.premiums.map(premiums => premiums.toJSON()),
          }
        });
        this.loading = false
        if (response.success) {
          this.$toast('success', this.$t('Premiums were successfully updated'));
          this.getReservation(this.$route.params.id);
          await this.hideFinancialItemPremiumsModal()
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else {
            this.model.setErrors(response.body)
          }
        }
      },
      onShow() {
        this.model = new PremiumsFormData({
          minimum_premium: this.editObject.minimum_premium,
          premiums: this.editObject.premiums.map(data => new Premium(data))
        }, this.reservation.lot.financial_item.tax_rate)
      },
      onHidden() {
        this.model = {};
        this.hideFinancialItemPremiumsModal();
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>

